<template>
  <div class="filter-wrapper">
    <a-form :model="filterData">
      <div class="df">
        <a-form-item label="规则名称：" style="margin-right: 20px;">
          <a-input
            v-model:value="filterData.activityName"
            style="width: 120px"
          />
        </a-form-item>
        <a-form-item label="状态：">
          <a-select
            ref="select"
            v-model:value="filterData.status"
            style="width: 120px"
            :allowClear="true"
          >
            <a-select-option :value="1" key="启用">启用</a-select-option>
            <a-select-option :value="2" key="禁用">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <div class="btn-wrapper">
          <a-button class="mr10" type="primary" @click="initList"
            >查询</a-button
          >
          <a-button @click="resetFilter">重置</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  margin-bottom: 10px;
}
.btn-wrapper {
  margin-left: auto;
}
</style>
